<template>
  <div v-on-clickaway="exitEditMode" class="header-element">
<!--    <div class="top-action">-->
<!--      <b-button-group>-->
<!--        <b-button class="el-move-action" v-b-popover.hover.left="`Déplacer l'élément`"><font-awesome-icon :icon="['fas', 'grip-lines']" /></b-button>-->
<!--        <b-button-->
<!--                @click="openEditElementModal({element: data, elindex})"-->
<!--        >-->
<!--          <font-awesome-icon :icon="['fas', 'edit']" /></b-button>-->
<!--        <b-button-->
<!--                @click="deleteElement"-->
<!--        ><font-awesome-icon :icon="['fas', 'trash-alt']" /></b-button>-->
<!--      </b-button-group>-->
<!--    </div>-->
    <draggable class="header-content" @change="handleAddData" :list="childElements" group="tableauColonne">
<!--      <span v-if="!childElements.length">Glissez puis déposez des éléments depuis la colonne de gauche </span>-->
<!--      <bloc-donnees-element v-else :element="this.data" class="center" />-->

        <table class="bloc-donnees w-100" cellpadding="10">
            <tbody>
            <tr>
                <td v-for="data in this.data.childElements" :key="'data-'+ data.childElements[0].key" :style="formatStyle(data.style.column)">
                    <span v-for="child in data.childElements" :key="child.key">
                        <h4 class="custom-header">{{ child.titre }}</h4>
                        <h4 class="custom-header custom-last">{{ getFicheInfo().espaceData[child.key] }}</h4>
                    </span>
<!--                    <span class="d-flex px-1" :style="formatStyle(data.style.column)">Code</span>-->
<!--                    <span class="d-flex px-1" :style="formatStyle(data.style.column)">{{ getFicheInfo().espaceData[data.childElements[0].key] }}</span>-->
                </td>
            </tr>
            </tbody>
        </table>
    </draggable>
    <edit-element
            @elementUpdate="handleElementUpdate"
            ref="editElement"
    />
  </div>
</template>

<script>
import editElement from '../modal/editElement'
import draggable from 'vuedraggable'
import { mapGetters, mapActions } from 'vuex'
import { directive as onClickaway } from 'vue-clickaway'
import { removeHtmlTag } from '../../../utils/util'
import blocDonneesElement from '../display/blocDonneesElement'
export default {
  directives: {
    onClickaway: onClickaway
  },
  components: {
    draggable,
    editElement,
    blocDonneesElement
  },
  props: {
    data: {
      required: true
    },
    elindex: Number
  },
  data () {
    return {
      childElements: null,
      isEdit: false
    }
  },
  beforeMount () {
    this.childElements = this.data.childElements
  },
  watch: {
    data: {
      handler (newValue) {
        this.childElements = newValue.childElements
      },
      deep: true
    }
  },
  methods: {
    ...mapGetters(['getFicheInfo']),
    ...mapActions(['updateSelectedCellValue', 'addDroppedHeader']),
    formatStyle (style) {
      let res
      switch (style.justifyContent) {
        case 'flex-start':
          res = {...style, textAlign: 'left'}
          break
        case 'center':
          res = {...style, textAlign: 'center'}
          break
        case 'flex-end':
          res = {...style, textAlign: 'left'}
          break
        default:
          res = {...style, textAlign: 'justify'}
          break
      }
      return res
    },
    handleElementUpdate (data) {
      this.$emit('elementUpdate', {elindex: this.elindex, data})
    },
    deleteElement () {
      this.$emit('deleteElement', this.elindex)
    },
    handleAddData (data) {
      this.childElements = this.childElements.filter(el => el.key !== data.added.element.key)
      this.childElements.push(data.added.element)
      this.$emit('dropEdit', {elindex: this.elindex, value: this.childElements})
      this.addDroppedHeader(data.added.element.key)
      this.$emit('updateData', { headerKey: data.added.element.key, value: true })
    },
    exitEditMode () {
      if (this.isEdit) {
        this.isEdit = false
      }
    },
    openEditElementModal (data) {
      this.$refs['editElement'].open(data)
    },
    handleDataValueChange (key) {
      this.$refs[`input-${key}`][0].blur()
      const { ligne, onglet } = this.getFicheInfo()
      const payload = {
        onglet,
        lig: ligne,
        headerKey: key,
        valeur: removeHtmlTag(this.$refs[`input-${key}`][0].innerHTML).trim()
      }
      this.updateSelectedCellValue(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
    .header-element {
        margin:15px;
    }

    .custom-header {
        display: inline-block;
        margin:10px;
    }

    .custom-last {
        text-indent: 50px;
    }
  .drop-element{
    padding: 20px;
    margin-bottom: 20px;
    border: 2px dashed #2b3085;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    background-color: #FFF;
    text-align: center;
    font-size: 14px;
    .el-move-action{
      cursor: move;
    }
    .data-move-action{
      cursor: move;
    }
    .center{
      margin: auto;
      padding: 10px;
    }
    .top-action {
      position: absolute;
      top: 0;
      right: 0;
      height: 25px;
      margin-bottom: 20px;
      text-align: center;
      background-color: #d2d3e5;
      width: 100%;
      button{
        background-color: transparent;
        border: none;
        color: #2b3085;
        border-radius: 0;
        font-weight: normal;
        box-shadow: none !important;
        padding-left: 5px;
        padding-right: 5px;
        height: 25px;
        line-height: 25px;
        margin-top: -2px;
        &:hover{
          color: #2b3085;
        }
        &:active{
          background-color: #2b3085;
          color: #fff;
        }
      }
    }
    .drop-content{
      margin-top: 20px;
      font-style: italic;
      color: rgba($color: #000000, $alpha: 0.4);
      font-weight: bold;
      font-size: 16px;
      table{
        tr{
          font-size: 14px;
          td:first-child{
            text-align: right;
            color: #444444;
            line-height: 23px;
          }
          td:last-child{
            padding-left: 10px;
            text-align: left;
            color: #2b3085;
            line-height: 23px;
          }
        }
      }
    }
    .drop-edit{
      margin-top: 20px;
      table{
        th{
          background-color: #4789B0;
          color: #FFF;
        }
        tfoot{
          text-align: right;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/ficheData.vue